import * as shapes from 'd3-shape';
import capitalize from 'lodash.capitalize';

/**
 Return the curve type for a given key.
 @param {String} [key='linear'] - The curve type key.
 @return {Object} The curve type.
 */
function getCurveType(key = 'linear') {
  return shapes[`curve${capitalize(key)}`];
}

export default getCurveType;
